// CopyQuestionSetModal.js
import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import PropTypes from "prop-types";

const CopyQuestionSetModal = ({
  isOpen,
  toggle,
  onCopyToSameTopic,
  onCopyToOtherTopics,
}) => {

  // Add inside the component
  const [step, setStep] = useState("choose"); // "choose" | "selectTopic"
  const [topicsInCollection, setTopicsInCollection] = useState([]);
  const [loadingTopics, setLoadingTopics] = useState(false);

  const [copySuccess, setCopySuccess] = useState(false);
  const [copyError, setCopyError] = useState(false);

  useEffect(() => {
    if (isOpen) setStep("choose");
    setCopySuccess(false);
    setCopyError(false);
  }, [isOpen]);

  const handleToOtherTopicsClick = async () => {
    setLoadingTopics(true);
    setStep("selectTopic");

    try {
      const res = await onCopyToOtherTopics(); // delegate fetching to parent
      setTopicsInCollection(res); // expects array of { _id, label }
    } catch (err) {
      console.error("Failed to load topics:", err);
    } finally {
      setLoadingTopics(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>複製題組</ModalHeader>
      <ModalBody style={{ textAlign: "center" }}>
        {copySuccess && <p style={{ color: "green", marginTop: "1rem" }}>✅ 複製成功</p>}
        {copyError && <p style={{ color: "red", marginTop: "1rem" }}>❌ 複製失敗，請再試一次</p>}
        {step === "choose" && (
          <>
            <Button color="primary" style={{ marginBottom: "1rem", width: "80%" }} 
              onClick={() => {
                onCopyToSameTopic(
                  () => {
                    console.log('HERE')
                    setCopySuccess(true);
                    setTimeout(() => toggle(), 1500);
                  },
                  () => {
                    setCopyError(true);
                  }
                )
              }}
            >
              複製到同主題
            </Button>
            <br />
            <Button color="secondary" style={{ width: "80%" }} 
              onClick={handleToOtherTopicsClick}
            >
              複製到同主題集中的其他主題
            </Button>
          </>
        )}

        {step === "selectTopic" && (
          <>
            {loadingTopics && <p>載入中...</p>}
            {!loadingTopics && topicsInCollection.length === 0 && <p>找不到其他主題。</p>}
            {!loadingTopics &&
              topicsInCollection.map((topic) => (
                <Button
                  key={topic._id}
                  color="light"
                  style={{ width: "100%", marginBottom: "0.5rem" }}
                  onClick={() => {
                    onCopyToOtherTopics(topic._id,
                      () => {
                        setCopySuccess(true);
                        //setTimeout(() => toggle(), 1500);
                      },
                      () => {
                        setCopyError(true);
                      }
                    )
                  }}
                >
                  {topic.label}
                </Button>
              ))}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          取消
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CopyQuestionSetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onCopyToSameTopic: PropTypes.func.isRequired,
  onCopyToOtherTopics: PropTypes.func.isRequired,
};

export default CopyQuestionSetModal;



